import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    .section {
      padding: 25px 40px;
    }
    .header-choose {
      height: 75px;
      background-color: rgba(236, 255, 184, 1);
      padding-left: 60px;
      display: flex;
      align-items: center;
    }
    .info {
      display: flex;
      margin-right: 25px;
      margin-bottom: 3px;
      justify-content: flex-end;
      align-items: center;
      margin-top: 34px;
      .transaction-number {
        padding-top: 4px;
        margin-bottom: 0px;
        background-color: #eeeeee;
        width: 100px;
        text-align: center;
        height: 26px;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
      }
      .number {
        padding-top: 4px;
        border: 1px solid #eeeeee;
        margin-bottom: 0px;
        width: 100px;
        text-align: center;
        height: 26px;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
      }
    }
    .pay {
      margin: 0px 25px;
      background-color: #eeeeee;
      .wrap-bill:first-child {
        margin: 0px 157px;
        padding-top: 68px;
      }
      .wrap-bill:nth-child(2) {
        padding-bottom: 34px;
      }
      .wrap-bill {
        margin: 0px 157px;
      }
      .bd-style {
        border-bottom: 1px dashed black;
        border-left: none;
        border-right: none;
        border-top: none;
      }
      .bd-solid {
        border-bottom: 1px solid black;
      }
      .bd-solid-2 {
        border-bottom: 2px solid black;
      }
      .detail-bill {
        margin-left: 60%;
        width: 40%;
        padding-top: 15px;
      }
      .txt-area {
        height: 111px;
      }
    }
    .pd-7 {
      padding-bottom: 7px;
    }
    .pd-15 {
      padding-bottom: 15px;
    }
    .pd-30 {
      padding-bottom: 30px;
    }
    .t-al {
      text-align: right;
    }
    .mgrl-25 {
      margin: 0px 25px;
    }
    .mgt-13 {
      margin-top: 13px;
    }
    .mgt-36 {
      margin-top: 36px;
      text-align: center;
    }
    .w-card {
      width: 196px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .w-bg {
      background-color: #c1e18d;
    }
    .w-bg-ec {
      background-color: #ecffb8;
    }
    .w-gb-gr {
      background-color: #f6f6f6;
    }
    .dl {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 40px;
    }
    .ant-col-4 {
      max-width: 20%;
    }
    .ant-card-head {
      height: 30px !important;
      min-height: 0px;
      text-align: center;
      border-bottom: none;
    }
    .ant-card-head-title {
      padding: 10px 0px;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
    }
    .ant-card-body {
      padding: 10px 10px;
    }
    .money-info {
      padding: 24px;
      background-color: white;
      text-align: center;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
    }
    .confirm-step {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn-save {
      background-color: #ff8a00;
      border-radius: 4px;
      color: white;
      border: none;
      width: 240px;
      height: 60px;
    }
    .btn-cancel-save {
      width: 112px;
      height: 60px;
      background-color: #c4c4c4;
      border-radius: 4px;
      border: none;
      color: white;
      margin-right: 10px;
    }
    .error {
      color: red;
    }
  }
`;
